import React from "react";
import {Link, Navigate} from 'react-router-dom'
import {Loading} from '../custom/LoadingComponent'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import ClientFullRenderer from './ClientFullRendererComponent';
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

function ClientNew(props) {
    console.log('ClientNew Component render is invoked!');

    const client = {
        generalSection: {},
        headOffice: {}
    }

    if(props.dataStatus === ReduxDataStatus.IDLE || 
       props.dataStatus === ReduxDataStatus.LOADING) {
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                <Loading />
            </Box>
            </Container>
        );
    }
    else if(props.mostRecentClientId != null) {
        return(
            <Navigate to={`/clients/${props.mostRecentClientId}`} replace />
        );
    }
    else { 
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to='/clients'>Clienti</Link>
                            <Typography color="text.primary">Adauga Client</Typography>
                        </Breadcrumbs>
                    </Box>                

                    <Box>
                        <h3>Client Nou</h3>
                    </Box>
                    <hr/>
    
                    <ClientFullRenderer 
                        client={client} 
                        saveClient={props.postClient} 
                    />

                </Stack>

            </Box>
            </Container>
        );
    }

}

export default ClientNew;